import { Clock3 } from "lucide-react";
import { StateBadge } from "./StateBadge";

/** The Friday recap: when it goes out and to whom. */
export const WeeklyStatus = ({ schedule, clock, state }) => (
  <div
    data-testid="weekly-status"
    className="mt-3 rounded-lg border border-border bg-[color:var(--tt-surface-2)] px-4 py-3.5"
  >
    <div className="flex flex-wrap items-center justify-between gap-2">
      <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-primary">
        Week in review
      </p>
      <StateBadge state={state} testId="weekly-status-badge" />
    </div>
    <p className="mt-2 text-[13px] leading-relaxed text-muted-foreground">
      Quotes sent and their value, won, lost, still waiting and anyone left waiting too long —
      emailed{" "}
      <span className="font-bold text-foreground" data-testid="weekly-schedule">
        {schedule.send_time_label || "—"}
      </span>{" "}
      to{" "}
      <span className="font-amount font-bold text-foreground" data-testid="weekly-recipients">
        {(schedule.recipients || []).join(", ") || "Nobody set"}
      </span>
      .
    </p>
    <p className="mt-1.5 flex items-center gap-1 text-[11px] text-muted-foreground">
      <Clock3 className="h-3 w-3" aria-hidden="true" />
      next {schedule.next_send_label || "—"}
      {clock.label ? ` · ${clock.label}` : ""}
    </p>
  </div>
);
